import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { ROLE } from '@utils/constant'

const notificationRoutes = {
  path: 'notification',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.notification.list'),
  },
  children: [
    {
      path: '',
      name: 'notificationList',
      component: () => lazyLoadView(import('@views/Notification/list.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
      },
    },
    {
      path: 'registration',
      name: 'notificationRegistration',
      component: () =>
        lazyLoadView(import('@views/Notification/registration.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
        label: i18n.t('router.notification.add'),
      },
    },
    {
      path: ':id',
      name: 'notificationDetail',
      component: () => lazyLoadView(import('@views/Notification/details.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
        label: i18n.t('router.notification.details'),
      },
    },
  ],
}

export default notificationRoutes
